// extracted by mini-css-extract-plugin
export default {"footer":"EditUserForm_footer__b3nm-","formWrapper":"EditUserForm_formWrapper__lPNUF"};